import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import PopupModal from "./components/PopupModal";


// Components
import Home from "./components/Home";
import History from "./components/History";
import News from "./components/News";
import Contact from "./components/Contact";
import Menu from "./components/Menu";
import SiteFooter from "./components/SiteFooter";
import TermsAndConditions from "./components/TermsAndConditions";
import Administration from "./components/Administration";
import Accommodation from "./components/Accommodation";
import Timing from "./components/Timing";
import MainnMenu from "./components/MainMenu";
import Attract from "./components/Attract";
import PhotoGallery from "./components/PhotoGallery";
import Emagazine from "./components/Emagazine";
import Gurudev from "./components/Gurudev";
import Arayoor from "./components/Arayoor";
import BalakrishnaTemple from "./components/BalakrishnaTemple";



function App() {
  return (
    <Router>
      {/* <!-- Header --> */}
{/* <PopupModal /> */}
	<header className="header">
			<MainnMenu />
	</header>

	{/* <!-- Menu --> */}

	
	
	{/* <!-- Home --> */}
	<div >
    	 {/* Page Routes */}
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
			 {/* <Route path="home" element={<Home />} /> */}
            <Route path="/history" element={<History />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/menu" element={<Menu />} />
			<Route path="/termsandconditions" element={<TermsAndConditions />} />
			<Route path="/administration" element={<Administration />} />
			<Route path="/timing" element={<Timing />} />
			<Route path="/attract" element={<Attract />} />
			<Route path="/gallery" element={<PhotoGallery />} />
			<Route path="/emagazine" element={<Emagazine />} />
			<Route path="/gurudev" element={<Gurudev />} />
			<Route path="/arayoor" element={<Arayoor />} />
			<Route path="/balakrishnaTemple" element={<BalakrishnaTemple />} />
			
			</Routes>
        </div>
      </div>


		<footer class="footer" style={{padding:'0px'}}>
			<SiteFooter />
		</footer>
    </Router>
  );
}






export default App;
